<template>
  <div>
  <div class="status" v-if="(Object.keys(status).length > 0) && (Object.keys(groupInfo).length > 0)">
    <div class="active">
      <div class="text">
        <p>Active</p>
        <span>Total Policies</span>
        <p class="status_count">{{ checkStatusValue(status.active_total) }}</p>
        <span class="active-statusDetail">
          <router-link :to="{name:'MemberList',params:{status:'Active'}}">
            View Detail
          </router-link>
        </span>
      </div>
      <div class="percent">
        <circle-counter
          size="100px"
          dash-spacing="0"
          dash-count="100"
          stroke-width="8"
          active-stroke="#3BB54A"
          active-width="8"
          :active-count="status.active_percentage"
          text="Active"
          :percent="status.active_percentage"
        />
      </div>
    </div>
    <div class="withdrawn">
      <div class="text">
        <p>Withdrawn</p>
        <span>Total Policies</span>
        <p class="status_count">{{ checkStatusValue(status.withdrawn_total) }}</p>
        <span class="withdrawn-statusDetail">
          <router-link :to="{name:'MemberList',params:{status:'Withdrawn'}}">
            View Detail
          </router-link>
        </span>
      </div>
      <div class="percent">
        <circle-counter
          size="100px"
          dash-spacing="0"
          dash-count="100"
          stroke-width="8"
          active-stroke="#FEBF5E"
          active-width="8"
          :active-count="status.withdrawn_percentage"
          text="Withdrawn"
          :percent="status.withdrawn_percentage"
        />
      </div>
    </div>
    <div class="termed">
      <div class="text">
        <p>Termed</p>
        <span>Total Policies</span>
        <p class="status_count">{{ checkStatusValue(status.termed_total) }}</p>
         <span class="termed-statusDetail">
          <router-link :to="{name:'MemberList',params:{status:'Termed'}}">
            View Detail
          </router-link>
        </span>
      </div>
      <div class="percent">
        <circle-counter
          size="100px"
          dash-spacing="0"
          dash-count="100"
          stroke-width="8"
          active-stroke="#FF3D57"
          active-width="8"
          :active-count="status.termed_percentage"
          text="Termed"
          :percent="status.termed_percentage"
        />
      </div>
    </div>
   <div class="active" v-if="groupInfo.group_type === 'employer'">
      <div class="text">
        <p>Renewals</p>
        <span>Total Policies</span>
        <p class="status_count">{{ renewalsTotalCount }}</p>
        <span class="active-statusDetail">
          <!-- <router-link :to="{name:'RenewalsMemberList', params:{status:'Active'}}"> -->
          <router-link :to="{name:'RenewalsMemberList'}">
            View Detail
          </router-link>
        </span>
      </div>
    <div class="percent">
        <circle-counter
            size="100px"
            dash-spacing="0"
            dash-count="100"
            stroke-width="8"
            active-stroke="#3BB54A"
            active-width="8"
            :active-count="renewalPercentage"
            text="Renewals"
            :percent="renewalPercentage"
        />
      </div>
    </div>
  </div>
  <!-- <div class="status" v-if="(Object.keys(status).length > 0) && (Object.keys(groupInfo).length > 0)">
 <div class="active" v-if="groupInfo.group_type === 'employer'">
      <div class="text">
        <p>Switch Plan</p>
        <span>Total Policies</span>
        <p class="status_count">{{ switchableTotalCount }}</p>
        <span class="active-statusDetail">
          <router-link :to="{name:'switchPlans'}">
            View Detail
          </router-link>
        </span>
      </div>
    <div class="percent">
        <circle-counter
            size="100px"
            dash-spacing="0"
            dash-count="100"
            stroke-width="8"
            active-stroke="#3BB54A"
            active-width="8"
            :active-count="switchablePercentage"
            text="Switchable"
            :percent="switchablePercentage"
        />
      </div>
    </div>
  </div> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Api from "@/resource/Api";
export default {
  data () {
    return {
      renewalsTotalCount: 0,
      switchableTotalCount:0,
    }
  },
  computed: {
    ...mapGetters({
      status: "status",
      groupInfo: "groupInfo"
    }),

  switchablePercentage() {
    return this.status.total ? ((this.switchableTotalCount / this.status.total) * 100).toFixed(2) : '0.00';
  },

  renewalPercentage() {
    return this.status.total ? ((this.renewalsTotalCount / this.status.total) * 100).toFixed(2) : '0.00';
  }
  },
  created () {
    this.getTotalRenewalsCount();
    this.getTotalSwitchableCount();
  },
  methods:{
    getTotalRenewalsCount() {
      let url;
      let loader = this.$loading.show();
      url = `get-members?is_renewal=1&is_renewal_count=1`;
      Api.get(url)
          .then((res) => {
            this.renewalsTotalCount = res.data.data.total_count;
          })
          .catch((error) => {
            console.log("error");
          })
          .finally(() => {
            loader.hide();
          });
    },

     getTotalSwitchableCount() {
      let url;
      let loader = this.$loading.show();
      url = `get-members?plan_switch=1&plan_switch_count=1`;
      Api.get(url)
          .then((res) => {
            this.switchableTotalCount = res.data.data.total_count;
          })
          .catch((error) => {
            console.log("error");
          })
          .finally(() => {
            loader.hide();
          });
    },
    checkStatusValue (status) {
      return status ? status : 0
    }
  }
};
</script>

<style src="@/assets/css/group_dashboard/status_info.css" scoped></style>
